import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import UploadInvoiceFile from './views/upload-invoice-file.vue';
import ClientMatterData from './views/client-matter-data.vue';
import ClientSetup from './views/client-setup.vue';
import FeeDesignations from './views/fee-designations.vue';
import InfractionRules from './views/infraction-rules.vue';
import PhaseAliases from './views/phase-aliases.vue';
import FeeSheetRules from './views/fee-sheet-rules.vue';
import FeeSheets from './views/fee-sheets.vue';
import PhaseAssignment from './views/phase-assignment.vue';
import AuditorPage from './views/auditor-page.vue';
import FeeSheetTemplates from './views/fee-sheet-templates.vue';
import FeeSheetTemplatesForm from './views/fee-sheet-templates-form.vue';
import FileParseFormat from './views/file-parse-format.vue';
import FileParseFormatColumn from './views/file-parse-format-column.vue';
import SubmittedFiles from './views/submitted-files.vue';
import UserAssignedClients from './views/user-assigned.vue';
import {
  Login,
  SideNavInnerToolbar as defaultLayout,
  SingleCard as simpleLayout
} from '@questelservices/common-vue';
import store from './store';
import CommonModule, {checkForAzureAdCodeUrl} from '@questelservices/common';
import { getModule } from 'vuex-module-decorators';
import Batch from './views/batch/batch.vue';
import ClientBatches from './views/batch/client-batches.vue';
import ClientGroupData from './views/client-group-data.vue';
import Help from './views/help.vue';
import IncompleteUploads from './views/incomplete-uploads.vue';
import FeeBudgets from './views/fee-budgets.vue';
import Coding from './views/activity-planner/coding.vue';
import BatchSnapshot from './views/activity-planner/batch-snapshot.vue';
import Auditing from './views/activity-planner/auditing.vue';
import Comments from './views/activity-planner/comments.vue';
import AllComments from './views/all-comments.vue';
import CommentsResponse from './views/comments-response.vue';
import FileService from './views/file-service.vue'
import AgentSetup from './views/activity-planner/agent-setup.vue';
import ClientSummary from './views/activity-planner/client-summary.vue';
import PdfTranslatorView from './views/pdf-translator.vue';
import EBillingView from './views/e-billing.vue';
import AnalysisTriggers from './views/analysis-triggers.vue';
import InvoiceLookup from './views/invoice-lookup.vue';

const productName = 'QuestelServicesThor';
const commonState = getModule(CommonModule, store);

const menuItems = [
  {
    text: 'Home',
    path: '/home',
    icon: 'home'
  },
  {
    text: 'File Upload',
    icon: 'bulletlist',
    expanded: true,
    items: [
      {
        text: 'Upload Invoice File',
        path: '/upload-invoice-file',
        icon: 'upload'
      },
      {
        text: 'View Submitted Files',
        path: '/submitted-invoice-files',
        icon: 'filter'
      }
    ]
  },  
  {
    text: 'Activity Planner',
    icon: 'bulletlist',
    expanded: true,
    items: [
      {
        text: 'Coding',
        path: '/coding',
        icon: 'codeblock'
      },
      {
        text: 'Batch Snapshot',
        path: '/batch-snapshot',
        icon: 'refresh'
      },      
      {
        text: 'Auditing',
        path: '/auditing',
        icon: 'check'
      },
      {
        text: 'Comments',
        path: '/comments',
        icon: 'comment'
      },
      {
        text: 'Agent Setup',
        path: '/agent-setup',
        icon: 'preferences'
      },
      {
        text: 'Reports',
        path: '/client-summary',
        icon: 'chart'
      }
    ]
  },  
  {
    text: 'Comments',
    path: '/all-comments',
    icon: 'comment'
  },
  {
    text: 'Fee Type Rules',
    path: '/fee-designations',
    icon: 'filter'
  },
 /*{
    text: 'Infraction Rules',
    path: '/infraction-rules',
    icon: 'key'
  },
  {
    text: 'Fee Sheet Rules',
    path: '/fee-sheet-rules',
    icon: 'key'
  },
  {
    text: 'Multiphase Aliases',
    path: '/phase-aliases',
    icon: 'key'
  },
  {
    text: 'User Assigned Clients',
    path: '/users',
    icon: 'key'
  },**/
  {
    text: 'Fee Sheets',
    path: '/fee-sheets',
    icon: 'money'
  },
  {
    text: 'Fee Sheet Templates',
    path: '/fee-sheet-templates',
    icon: 'tags'
  },
  {
    text: 'Fee Budgets',
    path: '/fee-budgets',
    icon: 'key'
  },
  {
    text: 'Client Matter Data',
    path: '/client-matter-data',
    icon: 'user'
  },
  {
    text: 'Client Group Data',
    path: '/client-group-data',
    icon: 'group'
  },
  {
    text: 'Analysis Triggers',
    path: '/analysis-triggers',
    icon: 'warning'
  },
  {
    text: 'E-Billing',
    path: '/e-billing',
    icon: 'chart'
  },
  {
    text: 'Client Setup',
    path: '/client-setup',
    icon: 'preferences'
  },
  {
    text: 'Comments Response',
    path: '/comments-response',
    icon: 'comment'
  },
  {
    text: 'Parse Format',
    path: '/file-parse-format',
    icon: 'variable'
  },
  {
    text: 'Invoice Lookup',
    path: '/invoice-lookup',
    icon: 'find'
  },
  {
    text: 'PDF Translator',
    path: '/pdf-translator',
    icon: 'globe'
  },
  {
    text: 'File Service',
    path: '/file-service',
    icon: 'doc'
  },
  {
    text: 'Help',
    path: '/help',
    icon: 'help'
  }
];

const layoutProps = { menuItems: menuItems, showAlert: false };

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/home',
      name: 'home',
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: Home
      },
      props: {
        layout: layoutProps
      }
    },
    {
      path: '/file-service',
      name: 'file-service',
      meta: { 
        requiresAuth: true,
        breadcrumbs: [
          { text: 'File Service' }
        ] 
      },
      components: {
        layout: defaultLayout,
        content: FileService
      },
      props: {
        layout: layoutProps
      }
    },
    {
      path: '/upload-invoice-file',
      name: 'upload-invoice-file',
      meta: {
        requiresAuth: true,
        breadcrumbs: [
          { text: 'Upload Invoice File' }
        ]
      },
      components: {
        layout: defaultLayout,
        content: UploadInvoiceFile
      },
      props: {
        layout: layoutProps
      }
    },
    {
      path: '/submitted-invoice-files',
      name: 'submitted-invoice-files',
      meta: {
        requiresAuth: true,
        breadcrumbs: [
          { text: 'View Submitted Files' }
        ]
      },
      components: {
        layout: defaultLayout,
        content: SubmittedFiles
      },
      props: {
        layout: layoutProps
      }
    },
    {
      path: '/coding',
      name: 'coding-work',
      meta: {
        requiresAuth: true,
        breadcrumbs: [
          { text: 'Coding' }
        ]
      },
      components: {
        layout: defaultLayout,
        content: Coding
      },
      props: {
        layout: layoutProps
      }
    },
    {
      path: '/batch-snapshot',
      name: 'batch-snapshot',
      meta: {
        requiresAuth: true,
        breadcrumbs: [
          { text: 'Batch Snapshot' }
        ]
      },
      components: {
        layout: defaultLayout,
        content: BatchSnapshot
      },
      props: {
        layout: layoutProps
      }
    },
    {
      path: '/auditing',
      name: 'auditing-work',
      meta: {
        requiresAuth: true,
        breadcrumbs: [
          { text: 'Auditing' }
        ]
      },
      components: {
        layout: defaultLayout,
        content: Auditing
      },
      props: {
        layout: layoutProps
      }
    },
    {
      path: '/comments',
      name: 'comments',
      meta: {
        requiresAuth: true,
        breadcrumbs: [
          { text: 'Comments' }
        ]
      },
      components: {
        layout: defaultLayout,
        content: Comments
      },
      props: {
        layout: layoutProps
      }
    },
    {
      path: '/agent-setup',
      name: 'agent-setup',
      meta: {
        requiresAuth: true,
        breadcrumbs: [
          { text: 'Agent Setup' }
        ]
      },
      components: {
        layout: defaultLayout,
        content: AgentSetup
      },
      props: {
        layout: layoutProps
      }
    },
    {
      path: '/client-summary',
      name: 'client-summary',
      meta: {
        requiresAuth: true,
        breadcrumbs: [
          { text: 'Reports'}
        ]
      },
      components: {
        layout: defaultLayout,
        content: ClientSummary
      },
      props: {
        layout: layoutProps
      }
    },
    {
      path: '/all-comments',
      name: 'all-comments',
      meta: {
        requiresAuth: true,
        breadcrumbs: [
          { text: 'All Comments' }
        ]
      },
      components: {
        layout: defaultLayout,
        content: AllComments
      },
      props: {
        layout: layoutProps
      }
    },
    {
      path: '/fee-designations',
      name: 'fee-designations',
      meta: {
        requiresAuth: true,
        breadcrumbs: [
          { text: 'Fee Type Rules' }
        ]
      },
      components: {
        layout: defaultLayout,
        content: FeeDesignations
      },
      props: {
        layout: layoutProps
      }
    },
    {
      path: '/fee-sheet-templates',
      name: 'fee-sheet-templates',
      meta: {
        requiresAuth: true,
        breadcrumbs: [
          { text: 'Fee Sheet Templates' }
        ]
      },
      components: {
        layout: defaultLayout,
        content: FeeSheetTemplates
      },
      props: {
        layout: layoutProps
      }
    },
    {
      path: '/fee-sheet-templates-form/:id?',
      name: 'fee-sheet-templates-form',
      meta: {
        requiresAuth: true,
        breadcrumbs: [
          { text: 'Fee Sheet Templates Form' }
        ]
      },
      components: {
        layout: defaultLayout,
        content: FeeSheetTemplatesForm
      },
      props: {
        layout: layoutProps
      }
    },
    {
      path: '/infraction-rules',
      name: 'infraction-rules',
      meta: {
        requiresAuth: true,
        breadcrumbs: [
          { text: 'Infraction Rules' }
        ]
      },
      components: {
        layout: defaultLayout,
        content: InfractionRules
      },
      props: {
        layout: layoutProps
      }
    },    
    {
      path: '/fee-sheet-rules',
      name: 'fee-sheet-rules',
      meta: {
        requiresAuth: true,
        breadcrumbs: [
          { text: 'Fee Sheet Rules' }
        ]
      },
      components: {
        layout: defaultLayout,
        content: FeeSheetRules
      },
      props: {
        layout: layoutProps
      }
    },
    {
      path: '/phase-aliases',
      name: 'phase-aliases',
      meta: {
        requiresAuth: true,
        breadcrumbs: [
          { text: 'Multiphase Aliases' }
        ]
      },
      components: {
        layout: defaultLayout,
        content: PhaseAliases
      },
      props: {
        layout: layoutProps
      }
    },
    {
      path: '/client-batches/:clientId?',
      name: 'client-batches',
      meta: {
        requiresAuth: true,
        breadcrumbs: [
          { text: 'Client Batches', name: 'client-batches' }
        ]
      },
      components: {
        layout: defaultLayout,
        content: ClientBatches
      },
      props: {
        layout: layoutProps
      }
    },
    {
      path: '/client-matter-data/:clientId?',
      name: 'client-matter-data',
      meta: {
        requiresAuth: true,
        breadcrumbs: [
          { text: 'Client Matter Data', name: 'client-matter-data' }
        ]
      },
      components: {
        layout: defaultLayout,
        content: ClientMatterData
      },
      props: {
        layout: layoutProps
      }
    },
    {
      path: '/client-group-data',
      name: 'client-group-data',
      meta: {
        requiresAuth: true,
        breadcrumbs: [
          { text: 'Client Group Data' }
        ]
      },
      components: {
        layout: defaultLayout,
        content: ClientGroupData
      },
      props: {
        layout: layoutProps
      }
    },
    {
      path: '/client-setup',
      name: 'client-setup',
      meta: {
        requiresAuth: true,
        breadcrumbs: [
          { text: 'Client Setup' }
        ]
      },
      components: {
        layout: defaultLayout,
        content: ClientSetup
      },
      props: {
        layout: layoutProps
      }
    },
    {
      path: '/comments-response',
      name: 'comments-response',
      meta: {
        requiresAuth: true,
        breadcrumbs: [
          { text: 'Comments Response' }
        ]
      },
      components: {
        layout: defaultLayout,
        content: CommentsResponse
      },
      props: {
        layout: layoutProps
      }
    },
    {
      path: '/batch/:id',
      name: 'batch',
      meta: {
        requiresAuth: true,
        breadcrumbs: [
          { text: 'Client Batches', name: 'client-batches' },
          { text: 'Batch Details', name: 'batch' }
        ]
      },
      components: {
        layout: defaultLayout,
        content: Batch
      },
      props: {
        layout: layoutProps
      }
    },
    {
      path: '/users',
      name: 'user-assigned-clients',
      meta: {
        requiresAuth: true,
        breadcrumbs: [
          { text: 'User Assigned Clients' }
        ]
      },
      components: {
        layout: defaultLayout,
        content: UserAssignedClients
      },
      props: {
        layout: layoutProps
      }
    },
    {
      path: '/fee-sheets',
      name: 'fee-sheets',
      meta: {
        requiresAuth: true,
        breadcrumbs: [
          { text: 'Fee Sheets' }
        ]
      },
      components: {
        layout: defaultLayout,
        content: FeeSheets
      },
      props: {
        layout: layoutProps
      }
    },
    {
      path: '/phase-assignment/:id',
      name: 'phase-assignment',
      meta: {
        requiresAuth: true,
        breadcrumbs: [
          { text: 'Activity Planner', name: 'coding-work' },
          { text: 'Phase Assignment' }
        ]
      },
      components: {
        layout: defaultLayout,
        content: PhaseAssignment
      },
      props: {
        layout: layoutProps
      }
    },
    {
      path: '/auditing/:id',
      name: 'auditing',
      meta: {
        requiresAuth: true,
        breadcrumbs: [
          { text: 'Activity Planner', name: 'auditing-work' },
          { text: 'Auditing Page' }
        ]
      },
      components: {
        layout: defaultLayout,
        content: AuditorPage
      },
      props: {
        layout: layoutProps
      }
    },
    {
      path: '/file-parse-format',
      name: 'file-parse-format',
      meta: {
        requiresAuth: true,
        breadcrumbs: [
          { text: 'File Parse Format', name: 'file-parse-format' } 
        ]
      },
      components: {
        layout: defaultLayout,
        content: FileParseFormat
      },
      props: {
        layout: layoutProps
      }
    },
    {
      path: '/file-parse-format-column/:id?',
      name: 'file-parse-format-column',
      meta: {
        requiresAuth: true,
        breadcrumbs: [
          { text: 'File Parse Format', name: 'file-parse-format' },
          { text: 'File Parse Format Edit', name: 'file-parse-format-column' }
        ]
      },
      components: {
        layout: defaultLayout,
        content: FileParseFormatColumn
      },
      props: {
        layout: layoutProps
      }
    },
    {
      path: '/incomplete-uploads',
      name: 'incomplete-uploads',
      meta: {
        requiresAuth: true,
        breadcrumbs: [
          { text: 'Incomplete Uploads', name: 'incomplete-uploads' }
        ]
      },
      components: {
        layout: defaultLayout,
        content: IncompleteUploads
      },
      props: {
        layout: layoutProps
      }
    },
    {
      path: '/fee-budgets',
      name: 'fee-budgets',
      meta: {
        requiresAuth: true,
        breadcrumbs: [
          { text: 'Fee Budgets', name: 'fee-budgets' }
        ]
      },
      components: {
        layout: defaultLayout,
        content: FeeBudgets
      },
      props: {
        layout: layoutProps
      }
    },
    {
      path: '/e-billing',
      name: 'e-billing',
      meta: {
        requiresAuth: true,
        breadcrumbs: [
          { text: 'E-Billing', name: 'e-billing' }
        ]
      },
      components: {
        layout: defaultLayout,
        content: EBillingView
      },
      props: {
        layout: layoutProps
      }
    },
    {
      path: '/analysis-triggers',
      name: 'analysis-triggers',
      meta: {
        requiresAuth: true,
        breadcrumbs: [
          { text: 'Analysis Triggers', name: 'analysis-triggers' }
        ]
      },
      components: {
        layout: defaultLayout,
        content: AnalysisTriggers
      },
      props: {
        layout: layoutProps
      }
    },
    {
      path: '/invoice-lookup',
      name: 'invoice-lookup',
      meta: {
        requiresAuth: true,
        breadcrumbs: [
          { text: 'Invoice Lookup', name: 'invoice-lookup' }
        ]
      },
      components: {
        layout: defaultLayout,
        content: InvoiceLookup
      },
      props: {
        layout: layoutProps
      }
    },
    {
      path: '/pdf-translator',
      name: 'pdf-translator',
      meta: {
        requiresAuth: true,
        breadcrumbs: [
          { text: 'PDF Translator', name: 'pdf-translator' }
        ]
      },
      components: {
        layout: defaultLayout,
        content: PdfTranslatorView
      },
      props: {
        layout: layoutProps
      }
    },
    {
      path: '/help',
      name: 'help',
      meta: {
        requiresAuth: true,
        breadcrumbs: [
          { text: 'Help' }
        ]
      },
      components: {
        layout: defaultLayout,
        content: Help
      },
      props: {
        layout: layoutProps
      }
    },
    {
      path: '/login',
      name: 'login',
      alias: ['/recovery', '/sessionExpired'],      
      meta: { requiresAuth: false },
      components: {
        layout: simpleLayout,
        content: Login
      },
      props: {
        content: { productName: productName, enableAzureAD: true },
        redirectUrl: '/home'
      }
    },    
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '*',
      redirect: '/home'
    }
  ]
});

router.beforeEach((to, from, next) => { 
  if (to.name === 'login' && commonState.authenticatedUser.authenticated) {
    next({ name: 'home' });
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!commonState.authenticatedUser.authenticated) {
      
      let codeQuery =  checkForAzureAdCodeUrl(to);

      next({
        name: 'login',
        query: codeQuery
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
